import { ApiConnection } from 'config';

const getPageById = async (id) => {
  const { data } = await ApiConnection.get(`pages?id=${id}`)
  return data.response
};

export default getPageById;